// services/menuLibelles.service.ts
//
// Libellés de menus personnalisés PAR ENTITÉ (backend /menus/libelles).
//
// Modèle de clés (identifiants STABLES) :
//   section:bloc.<id>            titre de super-bloc (Administration, ERP…)
//   section:rh.<k> / section:monEspace.<k>   titres de sections repliables
//   module:<id|cle>              entrée de 1er niveau (codée ou catalogue)
//   module:<cle>:lien:<path>     sous-lien d'un module du catalogue
//   route:<path>                 lien codé de la Sidebar (chemin unique)
//   route:<path>@<contexte>      lien codé dont le chemin apparaît plusieurs fois
import axiosInstance from './axios.config';

export interface LibelleMenu {
  cle: string;
  langue: string | null;
  libelle: string;
  entiteId: string;
  entiteNom: string | null;
  herite: boolean;
}

export interface LibelleMenuSaisie {
  cle: string;
  /** Vide = suppression de la surcharge. */
  libelle: string;
  langue?: string | null;
}

export const menuLibellesService = {
  async lister(): Promise<{ entiteId: string; libelles: LibelleMenu[] }> {
    const r = await axiosInstance.get('/menus/libelles');
    return r.data;
  },
  async enregistrer(libelles: LibelleMenuSaisie[]) {
    const r = await axiosInstance.put('/menus/libelles', { libelles });
    return r.data as { poses: number; supprimes: number; libelles: LibelleMenu[] };
  },
  async supprimer(cle: string, langue?: string | null) {
    const r = await axiosInstance.delete(`/menus/libelles/${encodeURIComponent(cle)}`, {
      params: langue ? { langue } : undefined,
    });
    return r.data;
  },
};
